import * as React from "react";
import { updateSettings } from "utils/DexieDBManager";

export enum VERSIONS_API_REQUEST_ACTIONS {
  ENABLE = "enable",
  DISABLE = "disable",
}

type Action =
  | { type: VERSIONS_API_REQUEST_ACTIONS.ENABLE }
  | { type: VERSIONS_API_REQUEST_ACTIONS.DISABLE };

type Dispatch = (action: Action) => void;

export type Settings = {
  versionsApiHasBeenCalled: boolean;
};

type SettingsProviderProps = { children: React.ReactNode };

type SettingsContextType = {
  state: Settings;
  dispatch: Dispatch;
};

export const SettingsContext = React.createContext<
  SettingsContextType | undefined
>(undefined);

function settingsReducer(_: Settings, action: Action) {
  if (action.type === VERSIONS_API_REQUEST_ACTIONS.DISABLE) {
    updateSettings({ key: "versionsApiHasBeenCalled", value: true });
    return { versionsApiHasBeenCalled: true };
  } else {
    throw new Error(`Unhandled action type`);
  }
}

function SettingsProvider({ children }: SettingsProviderProps) {
  const [state, dispatch] = React.useReducer(settingsReducer, {
    versionsApiHasBeenCalled: false,
  });

  const value = React.useMemo(() => ({ state, dispatch }), [state]);
  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
}

function useSettings() {
  const context = React.useContext(SettingsContext);
  if (context === undefined) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
}

export { SettingsProvider, useSettings };
